<template>
  <div>
    <DetailControl :title="content"></DetailControl>
  </div>
</template>

<script>
import { LOGIN_API } from "@/api.js";
import DetailControl from '@/components/detail/text.vue'
export default {
  components: {
    DetailControl,
  },
  data() {
    return {
      nowCategory: 0,
      content: '',
    }
  },
  created() {},
  mounted() {},
  methods: {
    loadDate() {
      let post = {
        category: this.nowCategory,
      }
      this.$axios
        .post(
          `${LOGIN_API}/customer/api/config`,
          post
        )
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              console.log(res.data)
              this.content = res.data.result[0].data
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
  },
  computed: {
    category() {
      return this.$store.state.app.category
    },
  },
  watch: {
    category: function (newVal, oldVal) {
      // 其他业务代码
      if (newVal != 0 && newVal != oldVal) {
        this.nowCategory = newVal
        this.loadDate()
      }
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/detail/index.vue